/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Hidden from '@ion/dls/src/layout/Hidden';
import Render from '@ion/dls/src/render/Render';
import useThemeContext from '@ion/dls/src/theme/useThemeContext';
import ContactSupport from '@ion/features/src/support/ContactSupport';
import Features, {hasAppNotificationAccess} from '@/security/Features';
import {preinitializeAdminUsers} from '@/store/actions/admin-users';
import {
  isPreInitializedSelector
} from '@/store/selectors/admin-users-selectors';
import {
  globalGroupIdSelector
} from '@/store/selectors/global-group-chooser-selectors';
import {
  userSelector
} from '@/store/selectors/login-selectors';
import {NotificationPanel} from '../components/notifications/NotificationPanel';
import {ToastNotificationsContainer} from '../components/notifications/ToastNotificationsContainer';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

/**
 * @ResponsiveHeader
 */
const ResponsiveHeader = () => {
  const canAccessNotification = hasAppNotificationAccess();
  const dispatch         = useDispatch();
  const {isCurrent}      = useThemeContext();
  const user             = useSelector(userSelector);
  const isProfleEnabled  = useSelector(isPreInitializedSelector);
  const currentAccountId = useSelector(globalGroupIdSelector);

  const [cancelToastDismiss, setCancelToastDismiss]     = useState([]);
  const [isContactSupportOpen, setIsContactSupportOpen] = useState(false);
  const [isAccountRestricted, setIsAccountRestricted]   = useState(Features.isCurrentAccountRestricted());

  useEffect(() => {
    if (!isProfleEnabled && user?.account && currentAccountId) {
      dispatch(preinitializeAdminUsers(currentAccountId));
    }
    setIsAccountRestricted(Features.isCurrentAccountRestricted());
  }, [user, currentAccountId]);

  const onContactSupportClose = useCallback(function() {
    setIsContactSupportOpen(false);
  }, []);

  const onContactSupportOpen = useCallback(function() {
    setIsContactSupportOpen(true);
  }, []);

  return (
    <div>
      <Hidden show='desktop'>
        <Render.If condition={!isCurrent}>
          <DesktopHeader onContactSupportOpen={onContactSupportOpen} isAccountRestricted={isAccountRestricted} />
        </Render.If>
      </Hidden>
      <Hidden show='mobile'>
        <MobileHeader onContactSupportOpen={onContactSupportOpen} isAccountRestricted={isAccountRestricted} />
      </Hidden>
      <Render.If condition={canAccessNotification}>
        <NotificationPanel cancelToastDismiss={cancelToastDismiss}
          setCancelToastDismiss={setCancelToastDismiss} />
      </Render.If>
      <Render.If condition={canAccessNotification}>
        <ToastNotificationsContainer cancelToastDismiss={cancelToastDismiss}
          setCancelToastDismiss={setCancelToastDismiss} />
      </Render.If>
      <Render.If condition={isContactSupportOpen}>
        <ContactSupport onCancel={onContactSupportClose} />
      </Render.If>
    </div>
  );
};
export default React.memo(ResponsiveHeader);
